import { combineReducers } from "@reduxjs/toolkit";

import authApi from "store/api/auth";
import filterAPI from "store/api/common";
import blogApi from "store/api/content";
import dashboardApi from "store/api/dashboard";
import emailTemplatesApi from "store/api/emailTemplates";
import masterApi from "store/api/master";
import profileApi from "store/api/profile";
import roleApi from "store/api/role";
import settingsApi from "store/api/settings";
import userApi from "store/api/users";
import userTokenReducer from "store/reducers/token";
import uiReducer from "store/reducers/ui";
import woundManagement from "store/api/woundManagement";
import permissionsReducer from "./permissions";
import questionnaireApi from "store/api/questionnarie";

/** ***************** 
@purpose : root reducer
@Author : INIC
@return : combine reducers
***************** */

export default () =>
  combineReducers({
    ui: uiReducer,
    token: userTokenReducer,
    permissions: permissionsReducer,
    [authApi.reducerPath]: authApi.reducer,
    [profileApi.reducerPath]: profileApi.reducer,
    [masterApi.reducerPath]: masterApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
    [roleApi.reducerPath]: roleApi.reducer,
    [emailTemplatesApi.reducerPath]: emailTemplatesApi.reducer,
    [blogApi.reducerPath]: blogApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [filterAPI.reducerPath]: filterAPI.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [questionnaireApi.reducerPath]: questionnaireApi.reducer,
    [woundManagement.reducerPath]: woundManagement.reducer,
  });

/** ***************** 
@purpose : RTK Query middlwares
@Author : INIC
@return : array of middlewares
***************** */
export const getReducerMiddlewares = () => [
  authApi.middleware,
  profileApi.middleware,
  settingsApi.middleware,
  userApi.middleware,
  masterApi.middleware,
  roleApi.middleware,
  emailTemplatesApi.middleware,
  blogApi.middleware,
  filterAPI.middleware,
  dashboardApi.middleware,
  questionnaireApi.middleware,
  woundManagement.middleware,
];
